export default "__VITE_ASSET__Cos49e6h__"